import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export const Field = ({ label, htmlFor, hint, children, className = "" }) => (
  <div className={`space-y-1.5 ${className}`}>
    <Label htmlFor={htmlFor} className="text-sm font-medium text-slate-800">{label}</Label>
    {children}
    {hint && <p className="text-xs text-slate-500">{hint}</p>}
  </div>
);

export const Sel = ({ value, onChange, options, placeholder, testId, id, className = "", disabled }) => (
  <select
    id={id}
    data-testid={testId}
    value={value ?? ""}
    disabled={disabled}
    onChange={(e) => onChange(e.target.value)}
    className={`h-11 w-full rounded-md border border-input bg-white px-3 text-[15px] text-slate-900 focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-60 ${className}`}
  >
    {placeholder !== undefined && <option value="">{placeholder}</option>}
    {options.map((o) => (
      <option key={o.value} value={o.value}>{o.label}</option>
    ))}
  </select>
);

export const Spinner = ({ className = "h-5 w-5" }) => <Loader2 className={`animate-spin ${className}`} />;

export const Empty = ({ text, testId }) => (
  <div data-testid={testId} className="rounded-xl border border-dashed border-slate-300 bg-white px-6 py-10 text-center text-slate-500">{text}</div>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
      {subtitle && <p className="text-slate-500 mt-1">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

export const Card = ({ children, className = "", testId }) => (
  <section data-testid={testId} className={`rounded-xl border border-slate-200 bg-white ${className}`}>{children}</section>
);

export const opts = (list) => (list || []).map((x) => ({ value: x, label: x }));
export const mapOpts = (map) => Object.entries(map).map(([value, v]) => ({ value, label: v.label || v }));
